import { useSelector, useDispatch } from 'react-redux';
import { updateCloneBilling, triggerValidation } from '../store/actions';
import { ShoppingCartBar, Billing, Requestor, PaymentMethod, SubmitOrder } from '../components';
const Checkout = () => {
    const dispatch = useDispatch();

    const { cloneBilling } = useSelector((state) => state.order);
    const handleCloneBilling = () => {
        dispatch(updateCloneBilling(!cloneBilling));
        dispatch(triggerValidation());
    }

    return (
        <div className="d-flex flex-column min-vh-100">

            <ShoppingCartBar customLink='cart' customText='Checkout' totalType='total' />

            <div className="mt-3"></div>
            <div className="mt-3"></div>

            <div className="mt-4" />
            <div className="flex-grow-1">
                <div className="card p-0">
                    <div className="card-header">
                        <span className="card-title">Submit Order</span>
                    </div>

                    <div className="card-body">

                        <div className="d-md-flex flex-row justify-content-between">
                            <div className="col-md-6 col-sm-12 d-flex flex-column">

                                <Billing />

                                <div className="mt-3"></div>

                                <div className="d-flex flex-row justify-content-between">
                                    <b>Service Contact</b>
                                    {cloneBilling ? (
                                        <div>
                                            same as billing - <span className='decorated-link' onClick={handleCloneBilling}>change</span>
                                        </div>
                                    ) : (
                                        <div>
                                            different than billing - <span className='decorated-link' onClick={handleCloneBilling}>change</span>
                                        </div>
                                    )}
                                </div>

                                {!cloneBilling && (
                                    <>
                                        <div className="mt-3"></div>
                                        <Requestor />
                                    </>
                                )}
                            </div>
                            <div className="col-md-6 col-sm-12 d-flex flex-column justify-content-between" >
                                <div className="mt-3"></div>
                                <PaymentMethod />
                                <SubmitOrder />
                            </div>
                        </div>

                    </div>

                </div>

                <div className="mt-3"></div>

                <div className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 d-flex align-items-center justify-content-end">
                                <div className="footer-copyright">
                                    ©2026 <a href="https://intocareers.net" target="_blank" rel="noreferrer" className="text-white">intoCareers</a>, <a href="https://uoregon.edu" target="_blank" rel="noreferrer" className="text-white">University of Oregon</a>. All rights reserved.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export { Checkout };


